import React, { useState, useEffect } from 'react'

const AppDevelopment = () => {
    const [activeService, setActiveService] = useState('consultation');

    useEffect(() => {
        // Add click event listeners to service tabs
        const tabs = document.querySelectorAll('.service-tab');
        const details = document.querySelectorAll('.service-detail');

        tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                const service = tab.getAttribute('data-service');

                // Remove active class from all tabs and details
                tabs.forEach(t => t.classList.remove('active'));
                details.forEach(d => d.classList.remove('active'));

                // Add active class to clicked tab and corresponding detail
                tab.classList.add('active');
                document.getElementById(service).classList.add('active');

                setActiveService(service);
            });
        });
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <section className="breadcrumb-hero">
                <div className="breadcrumb-overlay"></div>
                <div className="breadcrumb-content">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                {/* <div className="breadcrumb-tagline">
                                    <span className="breadcrumb-line"></span>
                                    <span className="breadcrumb-text">TRANSFORM YOUR IDEAS INTO REALITY</span>
                                </div> */}
                                <h1 className="breadcrumb-title">
                                    App <span className="breadcrumb-highlight">Development</span>
                                </h1>
                                <button className="breadcrumb-btn">
                                    <span>CONNECT NOW</span>
                                    <span className="breadcrumb-arrow">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="breadcrumb-pattern"></div>
            </section>

            {/* App Development Overview Section */}
            <section className="ai-driven-section">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="ai-driven-content">
                                <h2 className="ai-driven-title" style={{ textAlign: 'left' }}>
                                    <span className="text-gradient">Mobile & Web Application </span> Development Services
                                </h2>
                                <p className="ai-driven-description">
                                    In today's digital-first world, having a powerful mobile and web application is essential for business success. CLOUD MIND X specializes in creating custom, scalable, and user-centric applications that drive engagement, streamline operations, and deliver exceptional user experiences across all platforms. Our expert team transforms your vision into high-performing applications that exceed expectations.
                                </p>
                                <button className="ai-driven-btn">
                                    <span>TALK TO AN EXPERT</span>
                                    <span className="ai-driven-arrow">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </span>
                                </button>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="ai-driven-image-wrapper">
                                <img
                                    src="https://images.unsplash.com/photo-1551650975-87deedd944c3?w=800&q=80"
                                    alt="App Development Services"
                                    className="ai-driven-image"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* How We Help Section */}
            <section className="how-we-help-section">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="section-header text-center mb-5">
                                <span className="section-tagline">OUR EXPERTISE</span>
                                <h2 className="section-title" style={{ textAlign: 'center' }}>How We Help</h2>
                                <p className="text-muted lead m-0">
                                    With a proven track record in mobile and web application development and a team of 50+ skilled developers,<br />
                                    <span className="text-gradient">CLOUD MIND X</span> provides end-to-end app development services to help businesses<br />
                                    design, build, and maintain cutting-edge applications that drive results.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="row align-items-start">
                        {/* Left Side - Services Menu */}
                        <div className="col-lg-5">
                            <div className="services-menu">
                                <div className="service-tab active" data-service="consultation">
                                    <div className="service-tab-content">
                                        <h3 className="service-tab-title">App Consultation & Strategy</h3>
                                    </div>
                                </div>
                                <div className="service-tab" data-service="ui-ux">
                                    <div className="service-tab-content">
                                        <h3 className="service-tab-title">UI/UX Design</h3>
                                    </div>
                                </div>
                                <div className="service-tab" data-service="native">
                                    <div className="service-tab-content">
                                        <h3 className="service-tab-title">Native App Development</h3>
                                    </div>
                                </div>
                                <div className="service-tab" data-service="cross-platform">
                                    <div className="service-tab-content">
                                        <h3 className="service-tab-title">Cross-Platform Development</h3>
                                    </div>
                                </div>
                                <div className="service-tab" data-service="progressive">
                                    <div className="service-tab-content">
                                        <h3 className="service-tab-title">Progressive Web Apps</h3>
                                    </div>
                                </div>
                                <div className="service-tab" data-service="maintenance">
                                    <div className="service-tab-content">
                                        <h3 className="service-tab-title">App Maintenance & Support</h3>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Right Side - Service Details */}
                        <div className="col-lg-7">
                            <div className="service-details-container">
                                {/* App Consultation */}
                                <div className="service-detail active" id="consultation">
                                    <h3 className="service-detail-title">App Consultation & Strategy</h3>
                                    <p className="service-detail-description">
                                        We partner with you to define a clear roadmap for your application. Our consultation services include market analysis, competitive research, technology stack recommendations, monetization strategies, and feature prioritization. We ensure your app aligns with business goals and delivers measurable value from day one.
                                    </p>
                                    <button className="service-detail-btn">
                                        <span>Request Consultation</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>

                                {/* UI/UX Design */}
                                <div className="service-detail" id="ui-ux">
                                    <h3 className="service-detail-title">UI/UX Design</h3>
                                    <p className="service-detail-description">
                                        Create stunning and intuitive user experiences that captivate your audience. Our design team crafts pixel-perfect interfaces with user-centered design principles, interactive prototypes, and comprehensive design systems. We focus on accessibility, usability, and visual appeal to ensure users love every interaction with your app.
                                    </p>
                                    <button className="service-detail-btn">
                                        <span>Request Design Services</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>

                                {/* Native App Development */}
                                <div className="service-detail" id="native">
                                    <h3 className="service-detail-title">Native App Development</h3>
                                    <p className="service-detail-description">
                                        Build high-performance native applications for iOS and Android that leverage platform-specific features and capabilities. Our native development approach ensures optimal performance, seamless integration with device hardware, and exceptional user experiences that feel natural on each platform.
                                    </p>
                                    <button className="service-detail-btn">
                                        <span>Request Native Development</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>

                                {/* Cross-Platform Development */}
                                <div className="service-detail" id="cross-platform">
                                    <h3 className="service-detail-title">Cross-Platform Development</h3>
                                    <p className="service-detail-description">
                                        Maximize reach and minimize development time with cross-platform applications built using React Native, Flutter, or other modern frameworks. Deploy a single codebase across multiple platforms while maintaining native-like performance, reducing costs, and accelerating time-to-market.
                                    </p>
                                    <button className="service-detail-btn">
                                        <span>Request Cross-Platform Development</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>

                                {/* Progressive Web Apps */}
                                <div className="service-detail" id="progressive">
                                    <h3 className="service-detail-title">Progressive Web Apps (PWA)</h3>
                                    <p className="service-detail-description">
                                        Combine the best of web and mobile with Progressive Web Apps that work seamlessly across all devices. PWAs offer offline functionality, push notifications, fast loading times, and app-like experiences without the need for app store downloads. Perfect for businesses seeking broad accessibility and instant deployment.
                                    </p>
                                    <button className="service-detail-btn">
                                        <span>Request PWA Development</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>

                                {/* App Maintenance & Support */}
                                <div className="service-detail" id="maintenance">
                                    <h3 className="service-detail-title">App Maintenance & Support</h3>
                                    <p className="service-detail-description">
                                        Keep your application running smoothly with comprehensive maintenance and support services. We provide regular updates, bug fixes, performance optimization, security patches, OS compatibility updates, and feature enhancements to ensure your app stays current, secure, and competitive in the evolving digital landscape.
                                    </p>
                                    <button className="service-detail-btn">
                                        <span>Request Support Services</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* App Development Capabilities Section */}
            <section className="ai-capabilities-section">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="section-header text-center mb-5">
                                <span className="section-tagline-white">TECHNOLOGY EXCELLENCE</span>
                                <h2 className="section-title-dark">App Development Technologies & Platforms We Master</h2>
                                <p className="section-description-dark">
                                    CLOUD MIND X leverages cutting-edge technologies and frameworks to build robust, scalable, and innovative applications. Our expertise spans across <strong>mobile, web, and cloud platforms</strong>, ensuring we deliver solutions perfectly suited to your business needs across industries including healthcare, fintech, e-commerce, education, logistics, and entertainment.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        {/* iOS Development */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="12" y="8" width="24" height="32" rx="4" stroke="#4187f7" strokeWidth="2" />
                                        <circle cx="24" cy="36" r="1.5" fill="#4187f7" />
                                        <rect x="20" y="11" width="8" height="1" rx="0.5" fill="#4187f7" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">iOS Development</h4>
                                <p className="capability-description">
                                    Build premium iOS applications using Swift and SwiftUI that deliver exceptional performance and seamless integration with Apple's ecosystem. We create elegant, feature-rich apps optimized for iPhone, iPad, Apple Watch, and Apple TV, ensuring smooth user experiences and adherence to Apple's design guidelines.
                                </p>
                            </div>
                        </div>

                        {/* Android Development */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M18 12L24 6L30 12" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <rect x="14" y="16" width="20" height="24" rx="2" stroke="#4187f7" strokeWidth="2" />
                                        <circle cx="20" cy="22" r="1.5" fill="#4187f7" />
                                        <circle cx="28" cy="22" r="1.5" fill="#4187f7" />
                                        <rect x="18" y="28" width="12" height="8" rx="1" stroke="#4187f7" strokeWidth="2" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Android Development</h4>
                                <p className="capability-description">
                                    Develop powerful Android applications using Kotlin and Jetpack Compose that reach billions of users worldwide. Our Android apps are optimized for performance, battery efficiency, and diverse screen sizes, leveraging Google's latest frameworks and Material Design principles for consistent, intuitive experiences.
                                </p>
                            </div>
                        </div>

                        {/* React Native */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="24" cy="24" r="4" fill="#4187f7" />
                                        <ellipse cx="24" cy="24" rx="16" ry="6" stroke="#4187f7" strokeWidth="2" />
                                        <ellipse cx="24" cy="24" rx="16" ry="6" transform="rotate(60 24 24)" stroke="#4187f7" strokeWidth="2" />
                                        <ellipse cx="24" cy="24" rx="16" ry="6" transform="rotate(120 24 24)" stroke="#4187f7" strokeWidth="2" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">React Native</h4>
                                <p className="capability-description">
                                    Create cross-platform mobile apps with React Native that share a single codebase while delivering native performance. Perfect for businesses seeking rapid development, cost efficiency, and consistent user experiences across iOS and Android with near-native performance and seamless integration capabilities.
                                </p>
                            </div>
                        </div>

                        {/* Flutter Development */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 8L38 22L24 36L18 30L28 20L18 10L24 8Z" stroke="#4187f7" strokeWidth="2" strokeLinejoin="round" />
                                        <path d="M24 22L30 28L24 34L18 28L24 22Z" fill="#4187f7" opacity="0.3" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Flutter Development</h4>
                                <p className="capability-description">
                                    Leverage Flutter's powerful framework to build beautiful, natively compiled applications for mobile, web, and desktop from a single codebase. Experience lightning-fast development with hot reload, stunning UI components, and exceptional performance that rivals native applications across all platforms.
                                </p>
                            </div>
                        </div>

                        {/* Web Applications */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="8" y="12" width="32" height="24" rx="2" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M8 18H40" stroke="#4187f7" strokeWidth="2" />
                                        <circle cx="13" cy="15" r="1" fill="#4187f7" />
                                        <circle cx="17" cy="15" r="1" fill="#4187f7" />
                                        <circle cx="21" cy="15" r="1" fill="#4187f7" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Web Applications</h4>
                                <p className="capability-description">
                                    Develop responsive, scalable web applications using modern frameworks like React, Angular, Vue.js, and Next.js. Our web apps deliver desktop-class experiences with blazing-fast performance, real-time updates, offline capabilities, and seamless integration with backend services and third-party APIs.
                                </p>
                            </div>
                        </div>

                        {/* Cloud Integration */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M36 28C36 25 34 22 30 22C30 18 27 14 22 14C17 14 14 17 14 21C10 21 8 24 8 27C8 30 10 33 14 33H36C38 33 40 31 40 28C40 26 38 28 36 28Z" stroke="#4187f7" strokeWidth="2" strokeLinejoin="round" />
                                        <circle cx="24" cy="24" r="3" fill="#4187f7" opacity="0.3" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Cloud Integration</h4>
                                <p className="capability-description">
                                    Integrate your applications with leading cloud platforms including AWS, Google Cloud, and Microsoft Azure. We implement scalable cloud architectures, serverless functions, real-time databases, authentication systems, and cloud storage solutions that ensure reliability, security, and global accessibility.
                                </p>
                            </div>
                        </div>

                        {/* IoT & Wearables */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="24" cy="24" r="6" stroke="#4187f7" strokeWidth="2" />
                                        <circle cx="24" cy="24" r="14" stroke="#4187f7" strokeWidth="2" strokeDasharray="4 4" />
                                        <circle cx="24" cy="10" r="2" fill="#4187f7" />
                                        <circle cx="24" cy="38" r="2" fill="#4187f7" />
                                        <circle cx="10" cy="24" r="2" fill="#4187f7" />
                                        <circle cx="38" cy="24" r="2" fill="#4187f7" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">IoT & Wearables</h4>
                                <p className="capability-description">
                                    Build connected applications for Internet of Things devices and wearable technology. We develop solutions that seamlessly communicate with smart devices, fitness trackers, smartwatches, and IoT sensors, enabling real-time data collection, device control, and innovative user experiences in the connected world.
                                </p>
                            </div>
                        </div>

                        {/* API Development */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="10" y="10" width="12" height="12" rx="2" stroke="#4187f7" strokeWidth="2" />
                                        <rect x="26" y="10" width="12" height="12" rx="2" stroke="#4187f7" strokeWidth="2" />
                                        <rect x="10" y="26" width="12" height="12" rx="2" stroke="#4187f7" strokeWidth="2" />
                                        <rect x="26" y="26" width="12" height="12" rx="2" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M22 16H26M16 22V26M32 22V26M22 32H26" stroke="#4187f7" strokeWidth="2" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">API Development & Integration</h4>
                                <p className="capability-description">
                                    Design and implement robust RESTful and GraphQL APIs that power your applications and enable seamless third-party integrations. Our API solutions ensure secure data exchange, optimal performance, comprehensive documentation, and scalable architecture that grows with your business needs and ecosystem.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default AppDevelopment
